import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Songs from "@/pages/Songs";
import Setlists from "@/pages/Setlists";
import SetlistDetail from "@/pages/SetlistDetail";
import Performance from "@/pages/Performance";
import PublicSetlist from "@/pages/PublicSetlist";
import { api } from "@/lib/api";
import "@/App.css";

const TOAST_OPTIONS = {
  style: {
    background: "#1A1A1A",
    border: "1px solid #2D2D2D",
    color: "#fff",
  },
};

function App() {
  useEffect(() => {
    // Trigger seed in case backend was started before mongo was ready
    api.post("/seed").catch(() => {});
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/songs" element={<Songs />} />
            <Route path="/setlists" element={<Setlists />} />
            <Route path="/setlists/:id" element={<SetlistDetail />} />
          </Route>
          <Route path="/performance/:id" element={<Performance />} />
          <Route path="/share/:slug" element={<PublicSetlist />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" toastOptions={TOAST_OPTIONS} />
    </div>
  );
}

export default App;
